<template>
  <div class="container-d3-map" ref="mapContainer"></div>
</template>
<script>
import * as d3 from "d3"
import d3tip from "d3-tip"
import * as topojson from "topojson-client"
import { onMounted, ref } from "vue"

import MARKER_DATA from "./data/marker.json"
import WORLD_TOPOJSON from "./data/world.json"

export default {
  name: "D3Map",
  setup() {
    const mapContainer = ref(null)
    const markerData = MARKER_DATA
    const topojsonData = WORLD_TOPOJSON

    onMounted(() => {
      const tooltip = d3tip()
        .attr("class", "d3-tip")
        .html((d) => d)
      tooltip.offset([-8, -17])

      const width = 960
      const height = 500
      const svg = d3
        .select(mapContainer.value)
        .append("svg")
        .attr("width", width)
        .attr("height", height)
        .attr("viewBox", "0 0 " + width + " " + height)
        .attr("preserveAspectRatio", "xMinYMin")
      const def = svg.append("defs")
      const pinPath =
        "M9.651 23.759C9.464 23.919 9.232 24 9 24C8.768 24 8.536 23.919 8.349 23.759C8.008 23.466 0 16.504 0 9.043C0 4.057 4.037 0 9 0C13.963 0 18 4.057 18 9.043C18 16.504 9.992 23.466 9.651 23.759ZM9 2C5.141 2 2 5.16 2 9.043C2 14.445 7.148 19.866 8.999 21.64C10.85 19.864 16 14.435 16 9.043C16 5.16 12.859 2 9 2ZM9 13.074C6.794 13.074 5 11.28 5 9.074C5 6.869 6.794 5.074 9 5.074C11.206 5.074 13 6.869 13 9.074C13 11.28 11.206 13.074 9 13.074ZM9 7.074C7.898 7.074 7 7.971 7 9.074C7 10.177 7.898 11.074 9 11.074C10.103 11.074 11 10.177 11 9.074C11 7.971 10.103 7.074 9 7.074Z"
      const typeColorMapping = {
        mem: "#ffc32a",
        non: "#3f72b0",
      }
      def
        .append("pattern")
        .attr("id", "marker-mem")
        .attr("patternUnits", "objectBoundingBox")
        .attr("width", 10)
        .attr("height", 10)
        // Append svg to pattern
        .append("path")
        .attr("fill", typeColorMapping.mem)
        .attr("d", pinPath)
      def
        .append("pattern")
        .attr("id", "marker-non")
        .attr("patternUnits", "objectBoundingBox")
        .attr("width", 10)
        .attr("height", 10)
        // Append svg to pattern
        .append("path")
        .attr("fill", typeColorMapping.non)
        .attr("d", pinPath)
      def
        .append("pattern")
        .attr("id", "marker-hovered")
        .attr("patternUnits", "objectBoundingBox")
        .attr("width", 10)
        .attr("height", 10)
        // Append svg to pattern
        .append("path")
        .attr("fill", "#000000")
        .attr("d", pinPath)
      const g = svg.append("g").attr("class", "map")
      const projection = d3.geoMercator().center([0, 20]).scale(200).rotate([-90, 0])
      const path = d3.geoPath().projection(projection)
      const countryDefaultColor = "#f6f7f9"
      g.selectAll("path")
        .data(topojson.feature(topojsonData, topojsonData.objects.countries).features)
        .enter()
        .append("path")
        .attr("class", "country")
        .attr("data-country", (d) => d.properties.name)
        .attr("fill", countryDefaultColor)
        .attr("d", path)
      const getCountryPath = (name) => {
        const countryPath = svg.select(`.country[data-country="${name}"]`)
        return countryPath.empty() ? null : countryPath.node()
      }
      const markerG = svg.append("g").attr("class", "markers")
      const pinEnter = markerG.selectAll(".marker").data(markerData).enter()
      pinEnter
        .append("path")
        .attr("class", "marker")
        .attr("d", d3.symbol().size(575).type(d3.symbolSquare))
        .attr("transform", (d) => {
          return "translate(" + (projection([d.lng, d.lat])[0] + 5) + "," + (projection([d.lng, d.lat])[1] - 10) + ")"
        })
        .style("fill", function (d) {
          return `url(${location}#marker-${d.type})`
        })
        .on("mouseover", function (e, d) {
          const countryPath = getCountryPath(d.name)
          if (countryPath) {
            countryPath.style.fill = typeColorMapping[d.type]
            countryPath.classList.add("hovered")
          }
          e.currentTarget.style.fill = `url(${location}#marker-hovered)`
          const t =
            '<img src="/themes/custom/rimestheme/dist/assets/img/flags/' + d.id + '.webp" height="20px"/> ' + d.name
          tooltip.show(t, this)
        })
        .on("mouseout", function (e, d) {
          const countryPath = getCountryPath(d.name)
          if (countryPath) {
            countryPath.style.fill = countryDefaultColor
            countryPath.classList.remove("hovered")
          }
          e.currentTarget.style.fill = `url(${location}#marker-${d.type})`
          tooltip.hide(this)
        })
        .call(tooltip)
    })

    return {
      mapContainer,
    }
  },
}
</script>
